import { RouteConfig } from "vue-router";

export const ShopBoughtSoldRoutes: Array<RouteConfig> = [ {
                path: 'bought-sold',
                name: 'shop-bought-sold',
                component: () => import(/* webpackChunkName: "shop-bought-sold" */ './views/ShopBoughtAndSoldPage.vue'),
                children: []
        },
]